// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"90e7ba11","453":"fd3ac778","781":"c8e9e3c5","976":"9866940b"}[chunkId] + ".chunk.js";
};